
































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Quote, QuoteTerm } from '@/services/Quotes';
import { quoteProviderProcedures, isQuoteExpired } from '../../components/Quotes/QuoteFilters';
import QuoteDetails from '@/components/Quotes/QuoteDetails.vue';
import Alert from '@/components/Global/Alert.vue';
import AccordionList from '@/components/Global/Accordion/AccordionList.vue';
import Sidebar from '@/pages/Home/InsureCareTeams/InsureCareSideBar.vue';
@Component({
     name: 'BrokerQuoteDetails',
     components: {
          QuoteDetails,
          Alert,
          AccordionList,
          Sidebar,
     },
})
export default class BrokerQuoteDetails extends Vue {
     @Prop(Quote) public quoteProp: Quote;
     private quotes: any = [];
     private async created() {
          this.quotes.push(this.$route.params.quote);
     }

     private quoteExpiry(quote) {
          if (isQuoteExpired(quote) === 'expired') {
               return 'Expired';
          } else {
               return 'Quote Created';
          }
     }
}
